/**
 * Workspace Scope Hook
 * 
 * Hook to access WorkspaceScopeContext.
 * NO provider logic, NO context creation - just the hook.
 */

import { useContext } from 'react';
import { WorkspaceScopeContext } from './WorkspaceScope.context';

export function useWorkspaceScope() {
  const context = useContext(WorkspaceScopeContext);
  if (!context) {
    throw new Error('useWorkspaceScope must be used within WorkspaceScopeProvider');
  }
  return context;
}

